export default {
  isLoading: true,
  inMaintenance: false,
  data: null
};
